import React from 'react';
import About from '../About/About';
import Banner from '../Banner/Banner';
import Contact from '../Contact/Contact';
import Projects from '../Projects/Projects';

const Home = () => {
    return (
        <div className='max-w-[1200px] mx-auto'>
            <Banner></Banner>
            <Projects></Projects>
            <About></About>
            <Contact></Contact>
            <a
                href="#contact"
                className="fixed bottom-4 right-4 z-40 md:hidden btn-brand-primary shadow-lg"
            >
                Contact
            </a>
        </div>
    );
};

export default Home;